import React from "react"
import logo from "../../../assets/logo_only.png"
import { WBLabel } from "../../component/WBLabel";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import LogoName from "../../component/LogoName";

function KunjungiKami ({
    office
}) {
    return (
        <div className="mt-6 px-4 md:px-12 justify-center align-center">
            <div className="text-[12px] md:text-[16px] md:mt-10">
                <div className="text-center md:text-left font-black font-bold text-[30px] md:text-[30px]">
                    Hubungi Kami
                </div>
            </div>
            <div className="md:flex mt-4">
                <div className="md:w-[40vw] md:mr-8">
                    {(office && office.length > 0) ? 
                        <img className="rounded-lg" src={office[0]} />
                        :
                        <img className="rounded-lg" src={"https://images.unsplash.com/photo-1497366811353-6870744d04b2"} /> 
                    }
                </div>
                <div className="md:w-[40vw] mt-2 p-2">
                    <div className="hidden items-center md:flex">
                        <img src={logo} style={{ padding: 4}} width={64} height={64} />
                        {/* <WBLabel size={30} bold text={"Maxx Property"} /> */}
                        <LogoName/>
                    </div>
                    <div className="bg-gold h-[4px]"/>
                    <div className="text-[14px] text-left md:text-left md:text-[16px]">
                        <WBLabel size={20} bold text={"Visit Us : "} className={"mt-2"}/>
                        <div className="flex cursor-pointer text-blue-maxx font-normal" onClick={() => {
                            let outsideLink = document.createElement('a');
                            outsideLink.target= '_blank';
                            outsideLink.href= 'https://maps.app.goo.gl/CoxvpD4iENHBLdpe6';
                            outsideLink.click();
                        }}><FaLocationDot className="mt-1 mr-2 text-gold" size={30}/> Komplek Tritura Mas, Jalan AH Nasution No.A 12 A, Harjosari II, Kec. Medan Amplas, Kota Medan, Sumatera Utara 20228</div>
                        <WBLabel size={20} bold text={"Contact Us : "} className={"mt-2"}/>
                        <div className="flex cursor-pointer" onClick={() => {
                            let outsideLink = document.createElement('a');
                            outsideLink.target= '_blank';
                            outsideLink.href= `tel:08116380281`;
                            outsideLink.click();
                        }}><FaPhone className="mt-1 mr-2 text-gold"/>+628116380281</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KunjungiKami